import script from "./CsCustomerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CsCustomerDetail.vue?vue&type=script&setup=true&lang=js"

import "./CsCustomerDetail.vue?vue&type=style&index=0&id=7dcd90ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcd90ae"]])

export default __exports__